<svelte:options
  customElement={{
    tag: "oc-interactive-overlay-v1",
    /*                       */
    extend: window.__components.extend(),
    props: {
      base64Href: { type: "String", attribute: "base64-href" },
      ocAriaLabel: { type: "String", attribute: "oc-aria-label" },
      rel: { type: "String" },
      target: { type: "String" },
      borderRadius: {
        type: "String",
        attribute: "border-radius",
      },
      borderOffset: {
        type: "String",
        attribute: "border-offset",
      },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./InteractiveOverlayV1.types";
  import { InteractiveElement } from "../../../common/components/InteractiveElement";

  let {
    base64Href = undefined,
    target = undefined,
    rel = undefined,
    ocAriaLabel = undefined,
    borderRadius = undefined,
    borderOffset = undefined,
  }: Props = $props();

  const Host = $host<HTMLElement>();
</script>

<InteractiveElement
  {Host}
  asButton={true}
  bind:base64Href
  {target}
  {rel}
  class="root"
  {ocAriaLabel}
  style={`${borderRadius ? `--border-radius: ${borderRadius};` : ""}${borderOffset ? `--border-offset: ${borderOffset};` : ""}`}
>
  {#snippet children(onslotchange)}
    <slot {onslotchange} />
  {/snippet}
</InteractiveElement>

<style lang="scss" global>
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";
  @use "../../floating-focus/v1/FloatingFocusV1.shared" as floating-focus;

  :host {
    @include mixins.no-tap-highlight();
    position: relative;
    display: block;
    width: fit-content;

    /*        */
    --border-radius: unset;
    --border-offset: unset;
  }

  .root {
    &,
    ::slotted(a) {
      display: block;
      text-decoration: inherit;
      color: inherit;
      background: none;
      border: none;
      padding: 0;
      outline: none;
      outline-offset: 0; /*                                        */
      font: inherit;
      cursor: pointer;
    }

    /*                                           */
    &.-interactive,
    ::slotted(a) {
      /*                    */
      @include floating-focus.full-bleed();

      --oc-floating-focus-radius: var(--border-radius);

      &:before {
        content: "";
        position: absolute;
        inset: 0;
      }
    }

    /*                  */
    @media (hover: hover) {
      &.-interactive:hover,
      ::slotted(a:hover) {
        &:after {
          content: "";
          position: absolute;
          inset: calc(
            -1 * var(--border-offset, tokens.$oc-component-interactive-overlay-default-offset)
          );
          border-radius: var(
            --border-radius,
            tokens.$oc-component-interactive-overlay-default-border-radius
          );
          background-color: tokens.$oc-component-interactive-overlay-background-color-hover;
          pointer-events: none;
        }
      }
    }

    /*                  */
    &.-interactive:active,
    ::slotted(a:active) {
      &:after {
        content: "";
        position: absolute;
        inset: calc(
          -1 * var(--border-offset, tokens.$oc-component-interactive-overlay-default-offset)
        );
        border-radius: var(
          --border-radius,
          tokens.$oc-component-interactive-overlay-default-border-radius
        );
        background-color: tokens.$oc-component-interactive-overlay-background-color-active !important;
        pointer-events: none;
      }
    }
  }
</style>
